import {
  PayerEngagement,
  PayerEngagementStatus
} from "@wingspanhq/wingspan-api-sdk";

/**
 * Whether an assignment counts as live.
 *
 * `Created` counts alongside `Activated`: a client engagement is born `Created`
 * and only activates when the client accepts the link request, whereas v1's
 * implicit engagement was usable from the start. Treating both as active keeps
 * a newly-added client invoiceable, as it was on v1.
 */
export const selectorIsPayerEngagementActive = (
  engagement: PayerEngagement
): boolean =>
  engagement.status === PayerEngagementStatus.CREATED ||
  engagement.status === PayerEngagementStatus.ACTIVATED;
